import React, { useState } from 'react';
import Button from '../Button/Button';
import Modal, { ModalBody, ModalFooter } from '../Modal';
import { Flex } from 'rebass';
import { JobWithRwInspection } from './RecycledWaterInspectionThirdPane';
import { Input, Label } from '../Form';
import RichText from '../RichText/RichText';

type ModalColumnProps = {
  job: JobWithRwInspection;
  mailOptions: Partial<EmailOptions>;
  onClose: () => void;
};

type EmailOptions = {
  recipients: string;
  subject: string;
  body: string;
};

const RecycledWaterInspectionSchedulingModal: React.FC<ModalColumnProps> = ({
  job,
  onClose,
  mailOptions,
}) => {
  const recipients: string[] = [];
  if (job.recycledWaterInspection.contact?.emails?.[0]) {
    recipients.push(job.recycledWaterInspection.contact?.emails?.[0].value);
  }

  const [mailOptionsInput, setMailOptionsInput] = useState<EmailOptions>({
    subject: mailOptions.subject ?? '',
    body: mailOptions.body ?? '',
    recipients: mailOptions.recipients
      ? mailOptions.recipients
      : recipients.join(', '),
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setMailOptionsInput((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <Modal onClose={onClose} title="Email Customer">
      <ModalBody>
        <Flex sx={{ flexGrow: 1 }} flexDirection="column" m={3}>
          <Flex flex={1} flexDirection="column">
            <Label htmlFor="subject">Recipients</Label>
            <Input
              width="100%"
              name="recipients"
              value={mailOptionsInput.recipients}
              onChange={handleChange}
            />
          </Flex>
          <Flex flexDirection="column" mt={3}>
            <Label htmlFor="subject">Subject</Label>
            <Input
              width="100%"
              name="subject"
              value={mailOptionsInput.subject}
              onChange={handleChange}
            />
          </Flex>
          <Flex flexDirection="column" mt={3}>
            <RichText
              label="Message"
              value={mailOptionsInput.body}
              name="body"
              height="calc(100vh - 450px)"
              onChange={handleChange}
            />
          </Flex>
        </Flex>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose}>Send</Button>
        <Button variant="outline" icon="slash-circle" onClick={onClose}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RecycledWaterInspectionSchedulingModal;
